const DetailCard = ({label, value}: {label: string, value: string}) => {
  return (
    <div className="bg-blue-50 flex flex-col p-4 rounded-lg gap-1 border border-blue-100">
      <label className="text-[13px] text-g-300">{label}</label>
      <span className="text-[14px]">{value}</span>
    </div>
  )
}

export default DetailCard;